// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Ethiopia from '../_raw/flag/icon_flag_ethiopia.png';

export default () => <img src={Ethiopia} alt="Ethiopia" />;
